import {
  ThemeColors,
  TinyPopover,
  Toolbar,
} from '@octopus-do/octopus-storybook'
import { Globe, LinkExternalLight } from '@octopus-do/octopus-storybook/icons'
import type React from 'react'
import { forwardRef } from 'react'

import { isValidUrl } from '@/helpers'
import { MENU_OFFSET } from '../../constants'

// Key the popover reports to Toolbar.Root; the submitted url follows it.
export const EXTERNAL_LINK_ID = 'external_link'

const Content: React.FC = () => (
  <TinyPopover.LinkInput
    icon={Globe}
    placeholder="Enter URL..."
    validate={isValidUrl}
  />
)

interface TriggerProps {
  disabled: boolean
}

const Trigger = forwardRef<HTMLButtonElement, TriggerProps>(
  ({ disabled }, ref) => {
    const { active, toggle } = TinyPopover.useTrigger()

    return (
      <Toolbar.DropdownButton
        active={active}
        disabled={disabled}
        icon={LinkExternalLight}
        onClick={toggle}
        ref={ref}
        tooltip="External link"
      />
    )
  }
)

interface Props {
  disabled: boolean
}

// The action bar is an app control, light whatever the artboard theme is.
export const ExternalLinkPopover: React.FC<Props> = ({ disabled }) => {
  const { onClick } = Toolbar.useToolbarClick(EXTERNAL_LINK_ID)

  const onSubmit = (url: string) => onClick([url])

  return (
    <TinyPopover.Root
      content={Content}
      onSubmit={onSubmit}
      sideOffset={MENU_OFFSET}
      theme={ThemeColors.light}
    >
      <Trigger disabled={disabled} />
    </TinyPopover.Root>
  )
}
